import styled from '@emotion/styled'

export const DrawStyled = styled.canvas`
  background-image: ${(props) => `url(${props.src})`};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background-repeat: no-repeat;
  background-size: ${(props) => `${props.width}px ${props.height}px`};
`
